import React from "react";
import "./how-it-works.scss";
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';

const stepsData = [
  {
    step: 1,
    title: "Generate your unique design",
    desc: "Use our Design Engine to instantly generate beautiful, unique designs.",
    img: "/static/images/design1.png"
  },
  {
    step: 2,
    title: "Customize the colors",
    desc: "Choose from a wide range of colors and apply your perfect palette.",
    img: "/static/images/design2.png"
  },
  {
    step: 3,
    title: "Add your text, photo, or logo",
    desc: "Personalize your design by adding text, photos, or your brand logo.",
    img: "/static/images/design3.png"
  },
  {
    step: 4,
    title: "Adjust the position and transparency",
    desc: "Fine-tune the position and transparency to get the perfect look.",
    img: "/static/images/design4.png"
  },
  {
    step: 5,
    title: "Review your design",
    desc: "Take a moment to review every detail and make sure it's just right.",
    img: "/static/images/design5.png"
  },
  {
    step: 6,
    title: "Save or approve your final creation",
    desc: "Save your design or approve it to finalize your creation.",
    img: "/static/images/design6.png"
  }
];

const HowItWorks = () => {
  return (
    <div className="how_it_works_page">
      <div className="how_it_works_page__header">
        <h1>How It Works</h1>
        <p>Create something meaningful in 6 simple steps</p>
      </div>

      <div className="how_it_works_page__grid">
        {stepsData.map((data, index) => (
          <div className="step_card" key={index}>
            <div className="card_header">
              <span className="step_badge">{data.step}</span>
              <h2>{data.title}</h2>
            </div>
            
            <div className="video_mockup">
              <img src={data.img} alt={`Step ${data.step}`} className="video_poster" />
              
              <div className="play_overlay">
                <div className="play_circle">
                  <PlayArrowIcon />
                </div>
              </div>

              <div className="video_controls">
                <PlayArrowIcon className="control_icon" />
                <span className="time">0:00 / 0:30</span>
                <div className="progress_bar">
                  <div className="progress_fill">
                    <div className="progress_thumb"></div>
                  </div>
                </div>
                <VolumeUpIcon className="control_icon" />
                <FullscreenIcon className="control_icon" />
                <MoreHorizIcon className="control_icon" />
              </div>
            </div>

            <div className="card_body">
              <p>{data.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HowItWorks;
